export default __webpack_public_path__ + "static/media/Levitate D8.1 Integration of outputs of WP4-7.2e1603b8.pdf";